import { Reveal, SectionHead } from "@/components/Reveal";
import { Icon } from "@/components/Icon";
import { FEATURES, WHY_PLATFORM, POSTERS } from "@/data/site";

export const Platform = ({ onPoster }) => (
  <section id="platform" className="relative py-32 sm:py-40" data-testid="platform-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        eyebrow="01 — Platform Features"
        title="Everything a farm runs on, in one digital ecosystem."
        sub="Powered by technology. Designed for farmers. From crop production to market access, KMG Digi connects your farm, your partners and your future."
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mt-20">
        {FEATURES.map((f, i) => (
          <Reveal key={f.title} delay={i * 0.05}>
            <div
              data-testid={`feature-card-${i}`}
              className="lift h-full border border-[rgba(111,227,155,0.16)] bg-[color:var(--kmg-emerald)] p-7 hover:border-[color:var(--kmg-lime)]"
            >
              <Icon name={f.icon} size={22} className="text-[color:var(--kmg-lime)]" />
              <h3 className="font-display text-lg mt-6 leading-snug">{f.title}</h3>
              <ul className="mt-5 space-y-2.5">
                {f.items.map((it) => (
                  <li key={it} className="text-[13px] text-[color:var(--kmg-bone-dim)] flex gap-2.5 leading-relaxed">
                    <span className="text-[color:var(--kmg-gold)] mt-0.5">·</span>
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mt-28 items-center">
        <Reveal className="lg:col-span-5">
          <button
            onClick={() => onPoster(POSTERS.erp)}
            data-testid="platform-poster-btn"
            className="block w-full border border-[rgba(111,227,155,0.2)] overflow-hidden"
          >
            <img src={POSTERS.erp} alt="KMG Digi Platform features overview" className="w-full h-auto" />
          </button>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal>
            <p className="eyebrow">Why farmers choose KMG Digi</p>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-7 mt-8">
            {WHY_PLATFORM.map((w, i) => (
              <Reveal key={w.title} delay={i * 0.06}>
                <div data-testid={`why-platform-${i}`} className="flex gap-4">
                  <Icon name={w.icon} size={18} className="text-[color:var(--kmg-lime)] shrink-0 mt-1" />
                  <div>
                    <h4 className="font-display text-base">{w.title}</h4>
                    <p className="text-sm mt-1.5 text-[color:var(--kmg-bone-dim)]">{w.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
